<template>
  <div id="app">
    <nav>
      <div class="nav-wrapper">
        <router-link to="/" class="brand-logo">UP Day 18</router-link>
        <ConnectionStateIndicator />
        <ul id="menu">
          <li>
            <router-link to="/">
              <i class="material-icons">home</i>
            </router-link>
          </li>
          <li>
            <router-link to="/players">Joueurs</router-link>
          </li>
          <li>
            <router-link to="/teams">Equipes</router-link>
          </li>
          <li>
            <router-link to="/stats">Stats</router-link>
          </li>
          <li>
            <router-link to="/balance">Equilibre</router-link>
          </li>
          <li>
            <router-link to="/matches">Matchs</router-link>
          </li>
          <li>
            <router-link to="/tv">TV</router-link>
          </li>
          <li>
            <router-link to="/tables/1">Arbitrage table 1</router-link>
          </li>
          <li>
            <router-link to="/tables/2">Arbitrage table 2</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
import ConnectionStateIndicator from "@/components/ConnectionStateIndicator.vue";

export default {
  name: "app",
  components: {
    ConnectionStateIndicator
  }
};
</script>

<style>
.nav-wrapper {
  background-color: #f1f1f1;
  height: 4em;
  line-height: 4em;
  white-space: nowrap;
  box-shadow: 0.1em 0.3em 0.4em #bbb;
  padding-left: 1em;
  padding-right: 1em;
  text-align: right;
}

.brand-logo {
  text-decoration: none;
  color: #404040;
  font-size: 2em;
  font-weight: 600;
  float: left;
}

#menu {
  list-style-type: none;
}
#menu {
  display: inline-block;
  margin: 0;
}
#menu li {
  display: inline;
}

#menu li a {
  font-size: 1.2em;
  padding: 0.7em;
  color: #404040;
}

.material-icons{
  vertical-align: text-bottom;
}

@media only screen and (max-width: 992px) {
  #menu {
    display: none;
  }
}
</style>
